export default __webpack_public_path__ + "static/media/corporate6.a3a291b4.jpg";